module.exports = new __parcel__URL__("divineintervention.a3170b60.png").toString();